import styled from "styled-components"

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100vh;
  width: 100vw;
  overflow: hidden;
`

export const Main = styled.main`
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr;

  height: 100%;
  min-height: 0;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  min-height: 0;

  padding: 15px;
  overflow: hidden;

  h1 {
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 22px;
    }
  }
`

export const GroupBox = styled.div`
  flex: 1;
  min-height: 0;

  padding: 15px;

  display: flex;
  flex-direction: row;

  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.colors.text};

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const CalendarColumn = styled.div`
  width: 375px;
  height: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const Calendar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  border: 2px solid ${(props) => props.theme.colors.primaryBlue};
  border-radius: 8px;
  padding: 5px;

  margin-bottom: 10px;

  .rdp-month {
    background-color: #f5f5f5;
    margin: 0;
  }

  .rdp-chevron {
    fill: ${(props) => props.theme.colors.text};
  }

  .rdp-month_grid {
    border-collapse: unset;
  }

  .rdp-day {
    background-color: #c3e3fd;
    border-radius: 6px;
    cursor: pointer;

    width: 36px;
    height: 36px;
  }

  .rdp-day_button {
    font-size: 1rem;

    width: 100%;
    height: 100%;

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }

  .rdp-day:not(.rdp-day_disabled):hover {
    background-color: #e0f0ff;
    border-radius: 6px;
    cursor: pointer;
  }

  .rdp-selected .rdp-day_button {
    border: none;
    background-color: ${(props) => props.theme.colors.primaryBlue};

    color: ${(props) => props.theme.colors.white};
    font-weight: normal;

    width: 100%;
    height: 100%;
    border-radius: 5px;
  }

  .rdp-day_selected {
    background-color: #007bff;
    color: white;
  }

  .rdp-day_disabled {
    color: #ccc;
    cursor: not-allowed;
    text-decoration: line-through;
  }

  .rdp-today {
    color: ${(props) => props.theme.colors.contrastOrange};
    background-color: ${(props) => props.theme.colors.text};
  }
`

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: 10px;
  background: ${(props) => props.theme.colors.primaryBlue};

  border-radius: 8px;
  border: none;

  height: 36px;
  width: 100%;

  svg {
    color: white;
    height: 20px;
    width: 20px;
  }

  &:hover {
    background: ${(props) => props.theme.colors.secondaryBlue};
  }
`

export const StudentsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  width: 100%;
  height: 100%;

  margin-left: 35px;

  overflow: auto;

  svg {
    margin-left: 8px;
    width: 25px;
    height: 25px;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    margin-top: 15px;
    margin-left: 0px;
  }
`

export const AbsenceCard = styled.div`
  cursor: pointer;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  flex: 1;

  padding: 10px;
  border: 2px solid ${(props) => props.theme.colors.primaryBlue};

  p {
    color: black;
    font-size: 1.2rem;
    font-weight: 500;
  }

  div {
    display: flex;
    gap: 8px;
  }

  @media (max-width: 768px) {
    width: 100%;

    p {
      font-size: 0.9rem;
    }

    div {
      flex-direction: column;
    }
  }
`

export const AbsenceButton = styled.button<{ isAbsent: boolean }>`
  background-color: ${({ isAbsent, className }) => {
    if (className === "present" && isAbsent === false) {
      return "green"
    }
    if (className === "absent" && isAbsent === true) {
      return "red"
    }
    return "none"
  }};
  color: ${({ isAbsent, className }) => {
    if (
      (className === "present" && isAbsent === false) ||
      (className === "absent" && isAbsent === true)
    ) {
      return "white"
    }

    if (className === "present") {
      return "green"
    }

    if (className === "absent") {
      return "red"
    }
  }};
  padding: 5px;

  width: 100px;

  border: 2px solid;
  border-radius: 8px;

  &.present {
    &:not(:disabled):hover {
      background-color: lightgreen;
      color: white;
    }
  }

  &.absent {
    &:not(:disabled):hover {
      background-color: #f08080;
      color: white;
    }
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`
